<template lang="pug">
transition(
  name="fade"
  @before-leave="beforeLeave"
  @after-leave="afterLeave"
)
  slot
</template>

<script>
export default {
  name: "TransitionFade",
  methods: {
    beforeLeave(element) {
      element.style.left = `${element.offsetLeft}px`;
      element.style.width = `${element.offsetWidth}px`;
      element.style.height = `${element.offsetHeight}px`;
    },
    afterLeave(element) {
      element.style.left = ``;
      element.style.width = ``;
      element.style.height = ``;
    },
  }
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity ease 0.3s;
}

.fade-leave-active {
  position: absolute;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
